module.exports = __webpack_public_path__ + "img/1x.46db6e5.jpg";